import { DrakeFieldComponent } from 'app/drake-components/drake-field/drake-field.component';
import { AfterViewInit, Compiler, Component, EventEmitter, Input, NgModule, OnChanges, Output, SimpleChanges, ViewChild, ViewContainerRef, input } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DrakeGridComponent } from 'app/drake-components/drake-grid/drake-grid.component';
import { DrakeViewStandardComponent } from 'app/drake-components/drake-view-standard/drake-view-standard.component';
import { DrakeViewKpiComponent } from '../drake-view-kpi/drake-view-kpi.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@ngneat/transloco';
import { DrakeTimelineComponent } from '../drake-timeline/drake-timeline.component';
import { DrakeTreeComponent } from '../drake-tree/drake-tree.component';
import { DrakeSocialViewComponent } from '../drake-social-view/drake-social-view.component';
import { ChangePasswordComponent } from '../drake-change-password/drake-change-password.component';
import { FormsModule } from '@angular/forms';
import { DrakeCalendarViewComponent } from '../drake-calendar-view/drake-calendar-view.component';
import { DrakeChartsComponent } from 'app/drake-dashboards/drake-chart/drake-chart.component';
import { DrakeQuickAddComponent } from '../drake-quick-add/drake-quick-add.component';
import { DrakeListViewComponent } from '../drake-listview/drake-listview.component';
import { environment } from 'environments/environment';
import { DrakeImagePreviewComponent } from '../drake-image-preview/drake-image-preview.component';
import { Router, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { SVGIcon, downloadIcon} from '@progress/kendo-svg-icons';
import { NgForOf } from '@angular/common';
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { AuthService } from 'app/core/auth/auth.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({ 
    selector: 'app-drake-grid-custom-template',
    templateUrl: './drake-grid-custom-template.component.html',
    styleUrls: ['./drake-grid-custom-template.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, MatIconModule, TranslocoPipe, JsonPipe, RouterModule, ButtonsModule],
    providers:[JsonPipe, TranslocoPipe]
})
export class DrakeGridCustomTemplateComponent {
    @Input() templateStr: string;
  @Input() dataItem: any;
  @Input() column: any;

  @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;

  constructor(private compiler: Compiler) {}

  ngOnChanges() {
    this.render();
  }

  private render() {
    this.container.clear();

    // Creiamo un componente temporaneo che ospita la tua stringa dal DB
    const tmpCmp = Component({
      template: this.templateStr 
    })(class {
      dataItem: any;
      column: any;
    });

    // Creiamo un modulo per compilare il componente
    const tmpModule = NgModule({
      imports: [CommonModule],
      declarations: [tmpCmp]
    })(class {});

    this.compiler.compileModuleAndAllComponentsAsync(tmpModule).then((factories) => {
      const factory = factories.componentFactories.find(f => f.componentType === tmpCmp);
      const componentRef = this.container.createComponent(factory);
      
      // Passiamo i dati necessari alla stringa (dataItem e column)
      componentRef.instance.dataItem = this.dataItem;
      componentRef.instance.column = this.column;
    });
  }
    
}
